import { FETCH_ACCESSTOKEN } from '../actions/types';

const initialState = {
  data: []
};

export default function(state = initialState, action) {
  switch (action.type) {
    case FETCH_ACCESSTOKEN:
      return {
        ...state,
        data: action.payload.data
      };
    default:
      return state;
  }
}
